import React from "react";

import { PropsTypeSvg } from "@typings/global.types";

function DoneSvg({ classNameProps, height, width, colorFill }: PropsTypeSvg) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={classNameProps}
      width={width}
      height={height}
      viewBox='0 0 31 30'
      fill='none'
    >
      <circle cx='15.5' cy='15' r='12' className={colorFill} />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M22.585 10.9643C23.157 11.5635 23.135 12.513 22.5357 13.085L14.1667 21.0737L8.46429 15.6305C7.86504 15.0585 7.84296 14.109 8.41497 13.5097C8.98698 12.9105 9.93647 12.8884 10.5357 13.4604L14.1667 16.9263L20.4643 10.915C21.0635 10.343 22.013 10.365 22.585 10.9643Z'
        fill='white'
      />
    </svg>
  );
}

export default DoneSvg;
